import { SystemUsageData } from "../../../../../types"
import { numberToUSD } from "../../../../utils"
import Cell from "../../../billing-table/cell"
import HeaderCell from "../../../billing-table/header-cell"
import HeaderRow from "../../../billing-table/header-row"
import If from "../../../if"
import TableFooter from "../table-footer"
import TableWrapper from "../table-wrapper"

interface Props {
  usage: SystemUsageData
}

const AddonsBreakdown = ({ usage }: Props) => (
  <If
    condition={!!usage?.breakdown?.cost?.breakdown?.addons?.breakdown[0]?.type}
    then={
      <div>
        <div>
          <strong>Addons</strong>
        </div>
        <TableWrapper>
          <thead>
            <HeaderRow>
              <HeaderCell>LINE ITEM</HeaderCell>
              <HeaderCell className="text-center"> </HeaderCell>
              <HeaderCell className="text-center"> </HeaderCell>
              <HeaderCell className="text-right">LINE TOTAL</HeaderCell>
            </HeaderRow>
          </thead>
          <tbody className="divide-y divide-zinc-200">
            {usage?.breakdown?.cost?.breakdown?.addons?.breakdown?.map(
              (item, key) =>
                !!item?.type ? (
                  <tr key={key}>
                    <Cell>{item.label}</Cell>
                    <Cell className="text-center"> </Cell>
                    <Cell className="text-center"> </Cell>
                    <Cell className="text-right">
                      {item.type === "discount"
                        ? `(${numberToUSD(item.monthly_price)})`
                        : numberToUSD(item.monthly_price)}
                    </Cell>
                  </tr>
                ) : null
            )}
          </tbody>
          <TableFooter
            subTotal={usage?.breakdown?.cost?.breakdown?.addons?.total ?? 0}
          />
        </TableWrapper>
      </div>
    }
  />
)

export default AddonsBreakdown
